import classNames from 'classnames';
import React from 'react';
import { IconPointOne, IconPointThree, IconPointTwo, IconTick } from './icons';
import { Inline } from './layout';
import styles from './tick_row.css';
import { TextRegularLight, TextSmallLight } from './typography';

export function TickRow({
  children,
  size = 'medium',
  tickColor = 'purple',
  type = 'tick',
}: {
  children: React.ReactNode;
  size?: 'medium' | 'large' | 'small';
  tickColor?: 'purple' | 'inherit';
  type?: 'one' | 'two' | 'three' | 'tick';
}) {
  const Text =
    size === 'large' || size === 'medium' ? TextRegularLight : TextSmallLight;

  const icon =
    type === 'one' ? (
      <IconPointOne />
    ) : type === 'two' ? (
      <IconPointTwo />
    ) : type === 'three' ? (
      <IconPointThree />
    ) : (
      <IconTick />
    );

  return (
    <Inline spacing={8} yalign="center">
      <div
        className={classNames(
          styles.tick,
          tickColor === 'purple' && styles.isPurple,
          styles[size],
        )}
      >
        {icon}
      </div>
      <Text>{children}</Text>
    </Inline>
  );
}
